import React from 'react'
import { Box } from '@chakra-ui/react'
import PaymentGatewayTable from './components/PaymentGatewayTable'

export default function PaymentGatewaysView() {
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <PaymentGatewayTable />
    </Box>
  )
}
